import { NewAccountEvents } from "../entities/new_account-events.enum";
import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { parseList } from "@helpers/functions";
import { PayoutAccount } from "@models";
import { zip } from "rxjs";
import { NewAccount } from "../entities/new_account.model";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { PayAccountService } from "@main-services/pay_account.service";
import { AccountService } from "../../../account/services/account.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";

@Injectable({
	providedIn: "root"
})
export class New_AccountBridgeService {
	constructor(
		private readonly accountService: AccountService,
		private readonly translationService: TranslationService,
		private readonly masterdataService: MasterdataService,
		private readonly apiCallService: ApicallService,
		private readonly payService: PayAccountService
	) {}

	public getAccount(): NewAccount {
		return {
			fiat_id: this.accountService.account.getFiatId(),
			language: this.accountService.account.getLanguage(),
			marketing_tracking: this.accountService.account.getGoogleTracking(),
			swap_disabled: this.accountService.account.getSwapDisabled(),
			savings_disabled: this.accountService.account.getSavingsDisabled(),
			isDocumented: this.accountService.account.isDocumented(),
			bfc_enabled: this.accountService.account.bestFeeOptIn,
			digital_securities_trading_appropriateness: this.accountService.account.getTradingAppropriateness(),
			terms: this.accountService.account.getTerms(),
			event: this.accountService.account.getEvent() as NewAccountEvents,
			isSaving: this.accountService.account.saving,
			is_best2_terms_accepted: this.accountService.account.isBest2TermsAccepted(),
			instant_trade_bonus_disabled: this.accountService.account.isInstantTradeBonusDisabled()
		};
	}

	public fetchMembersData(): void {
		const lang: string = this.translationService.getLanguage();
		const payoutprovidersOption = new ApicallOption();
		payoutprovidersOption.apiVersion = "v3";
		this.masterdataService.initMasterdata(lang).subscribe(() =>
			zip(
				this.apiCallService.get("payoutproviders", payoutprovidersOption),
				this.apiCallService.get("payoutaccounts"),
				this.apiCallService.get("paymentoptions")
			)
				.pipe(take(1))
				.subscribe(([payoutProviders, payoutAccounts, paymentOptions]) => {
					this.masterdataService.setProviderFromData(payoutProviders, paymentOptions);
					this.masterdataService.checkLimits();
					this.payService.list = parseList(payoutAccounts, PayoutAccount);
				})
		);
	}

	public updateOldAccount(account: NewAccount): void {
		const oldAccount = this.accountService.account;
		oldAccount._fiat_id = account.fiat_id;
		oldAccount._language = account.language;

		this.accountService.account = oldAccount;
	}
}
